// Four-color preview of a grayscale hold-shape skin. The same shape is shown
// tinted to each of the 4 gameplay colors via CSS mask — mirroring how the
// in-game PixiHold tints the sprite — so players see that the skin still
// carries the color signal. Falls back to a tiny drawn arc when no image.
const TINTS = ['#E63946', '#3B82F6', '#F4C724', '#9B5DE5'];

export function HoldShapePreview({ url, accent }: { url: string | null; accent: string }) {
  return (
    <div
      style={{
        width: 60, height: 72, borderRadius: 10, background: 'rgba(0,0,0,0.3)',
        border: `1px solid ${accent}55`, flexShrink: 0,
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', gap: 5, padding: 6,
      }}
    >
      {url ? (
        TINTS.map((c) => (
          <div
            key={c}
            style={{
              width: 40, height: 11,
              backgroundColor: c,
              WebkitMaskImage: `url("${url}")`,
              maskImage: `url("${url}")`,
              WebkitMaskRepeat: 'no-repeat',
              maskRepeat: 'no-repeat',
              WebkitMaskPosition: 'center',
              maskPosition: 'center',
              WebkitMaskSize: 'contain',
              maskSize: 'contain',
            }}
          />
        ))
      ) : (
        TINTS.map((c) => (
          <div
            key={c}
            style={{ width: 36, height: 0, borderBottom: `2.5px solid ${c}`, borderRadius: 2 }}
          />
        ))
      )}
    </div>
  );
}
